import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Row, Col, message } from 'antd';

const UpdatePhoneModal = ({ visible, currentPhone, onCancel, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [countdown, setCountdown] = useState(0); // 倒计时
    const isBinding = !currentPhone;
    // 倒计时逻辑
    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [countdown]);

    // 发送验证码执行函数
    const handleSendCode = async () => {
        try {
            const { phone } = await form.validateFields(['phone']);
            console.log('正在向手机号发送验证码:', phone);
            // 调用你的后端发送接口
            // await sendSmsApi(phone);
            message.success('验证码已发送');
            setCountdown(60); // 开启60秒倒计时
        } catch (error) {
            // 如果手机号没填，validateFields 会自动触发错误提示
        }
    };

    // 提交表单
    const handleNext = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            console.log('提交的数据:', values);
            // 调用后端修改接口
            // await updatePhoneApi(values);
            message.success('手机号修改成功');
            onSuccess(); // 成功回调
        } catch (error) {
            console.log('验证失败:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={isBinding ? "绑定手机号" : "修改手机号"}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    取消
                </Button>,
                <Button key="submit" type="primary" onClick={() => form.submit()}>
                    {isBinding ? "立即绑定" : "下一步"}
                </Button>,
            ]}
            width={400}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ phone: '18200000000' }} // 演示数据
                style={{ marginTop: 20 }}
                onFinish={(values) => {
                    console.log('提交请求:', values);
                    onSuccess();
                }}
            >
                <Form.Item
                    label="手机号"
                    name="phone"
                    rules={[
                        { required: true, message: '请输入手机号' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式' }
                    ]}
                >
                    <Input
                        prefix="+86"
                        placeholder="请输入手机号"
                        size="large"
                        style={{ borderRadius: '6px' }}
                    />
                </Form.Item>

                <Form.Item label="验证码" required>
                    <Row gutter={8}>
                        <Col span={16}>
                            <Form.Item
                                name="code"
                                noStyle
                                rules={[{ required: true, message: '请输入验证码' }]}
                            >
                                <Input
                                    placeholder="请输入验证码"
                                    size="large"
                                    style={{ borderRadius: '6px' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Button
                                block
                                size="large"
                                disabled={countdown > 0}
                                onClick={handleSendCode}
                                style={{ borderRadius: '6px' }}
                            >
                                {countdown > 0 ? `${countdown}s` : '发送验证码'}
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default UpdatePhoneModal;